
export const gridSpacing = 3;
export const drawerWidth = 280;
export const appDrawerWidth = 320;
export const collapsedDrawerWidth = 64;

export const ROUTES = {
    ROOT: '/',
    DASHBOARD: '/dashboard',
    ADMIN: '/admin',
    ASSESSMENT: '/assessment',
    NOTIFICATION: '/notification',
    PROMPT_CATEGORY: '/promptCategory',
    LEADERS: '/leaders',
    PROMPTS: '/prompt',
    PROMPT_DATA_MODALS: 'prompt/:id',
    QUESTION: 'assessment/:id',
    ROLE: '/role',
    USER: '/user',
    USER_DETAILS: '/user/:id',
    DELETED_USERS: '/deleted-users',
    FEEDBACK: '/feedback',
    RE_ASSESSMENT_REQUESTS: 're-assessment-requests',
    EMAIL: '/email',
    SUPPORT_TICKETS: '/support-tickets',
    PERSONALITY_ARCHETYPES: '/personality-archetypes'
};

export const PROJECTIVE_PERSONALITY_COMBINATIONS = [
    'P1P2',
    'P1P3',
    'P2P1',
    'P2P3',
    'P3P1',
    'P3P2'
];

export const ASSESSMENT_CONTEXT = [
    {
        label: "Trait",
        value: "trait"
    },
    {
        label: "Projective",
        value: "projective"
    }
]